import { render, staticRenderFns } from "./InfiniteDataTable.vue?vue&type=template&id=bccf3738"
import script from "./InfiniteDataTable.vue?vue&type=script&lang=js"
export * from "./InfiniteDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports